// extracted by mini-css-extract-plugin
export default {"root":"SettingsCounter__root___HJbNS","switch":"SettingsCounter__switch___ZyuzU","switchLabel":"SettingsCounter__switchLabel___NgKsh"};